import { styled } from '@mui/material/styles'
import Tooltip, { tooltipClasses, TooltipProps } from '@mui/material/Tooltip'
import React from 'react'

interface BootstrapTooltipProps extends TooltipProps {
	bgColor?: string
	textColor?: string
	shadow?: boolean
	top?: string
}

export const BootstrapTooltip = styled(
	({ className, ...props }: BootstrapTooltipProps) => (
		<Tooltip {...props} arrow classes={{ popper: className }}>
			{props.children}
		</Tooltip>
	),
	{
		shouldForwardProp: prop =>
			prop !== 'bgColor' && prop !== 'textColor' && prop !== 'shadow',
	}
)(({ theme, bgColor, textColor, shadow, top }) => ({
	[`& .${tooltipClasses.arrow}`]: {
		color: bgColor || theme.palette.common.black,
	},
	[`& .${tooltipClasses.tooltip}`]: {
		top,
		backgroundColor: bgColor || theme.palette.common.black,
		fontFamily: 'Gilroy-Medium, sans-serif',
		fontSize: '0.9375rem',
		padding: '0.5rem',
		color: textColor || '#ffffff',
		boxShadow: shadow ? '0px 5px 10px 2px rgba(34, 60, 80, 0.2)' : 'none',
	},
}))
